import React, { useCallback, useState } from "react";
import Styles from "./style.module.scss";
import Icon from "@Atom/Icon";
import { useNavigate } from "react-router-dom";
import Button from "@Atom/Button";
import AdminDetailClass from "./ClassDetail";
import StudentListAdmin from "./StudentList";
import AbsenceClassAdmin from "./Absence";

export default function AdminClassDetail({ data }) {
  const navigate = useNavigate();
  const [tab, setTab] = useState(1);
  
  const renderComponent = useCallback(() => {
    switch (tab) {
      case 1:
        return <AdminDetailClass data={data.classValue} />;
      case 2:
        return <StudentListAdmin data={data.studentValue} />;
      case 3:
        return <AbsenceClassAdmin data={data.attendanceValue} />;
      case 4:
        return <StudentListAdmin data={data.studentValue} />;
      default:
        break;
    }
  }, [data, tab]);

  return (
    <div className={Styles.container}>
      <div className={Styles.breadcrumbsWrapper}>
        <div className={Styles.backIcon} onClick={() => navigate(-1)}>
          <Icon icon={"chevron-left"} size={16} />
        </div>
        <div className={Styles.breadcrumb}>
          <p>Daftar Kelas</p>
          <Icon icon={"chevron-right"} size={16} color={"#3E4856"} />
          <p>
            Mengelola Surat Menggunakan Sistem E-Filing untuk Sekretaris
            (Luring/Offline)
          </p>
        </div>
      </div>
      <div className={Styles.tabHeaderWrapper}>
        <Button
          variant="tab"
          text={"Detail Kelas"}
          isActive={tab === 1}
          onClick={() => setTab(1)}
        />
        <Button
          variant="tab"
          text={"Daftar Peserta"}
          isActive={tab === 2}
          onClick={() => setTab(2)}
        />
        <Button
          variant="tab"
          text={"Absensi Peserta"}
          isActive={tab === 3}
          onClick={() => setTab(3)}
        />
        <Button
          variant="tab"
          text={"Reflective Journal"}
          isActive={tab === 4}
          onClick={() => setTab(4)}
        />
      </div>
      {renderComponent()}
    </div>
  );
}
